// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Chat_wrapper__qAJxn","hide":"Chat_hide__l9mMr","chat-btn":"Chat_chat-btn___m80m"};